import { END_POINTS } from "../constants/url";
import { CommonBody, SubAdmin, SubAdminResponse } from "../types/General";
import emptySplitApi from "../utils/rtk";
type CommonResponseType = {
  statusCode: number;
  message: string;
};
type GetAllRolesResponse = {
  data: RoleResponse[];
  count: number;
};

export type RoleResponse = {
  _id: string;
  name: string;
  permission: Permission[];
  isDeleted: boolean;
  isBlocked: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
};

export type Permission = {
  sideBarId: number | string;
  label: string;
  isView: boolean;
  isAdd: boolean;
  isEdit: boolean;
  isDelete: boolean;
  _id: string;
};

type GetTokenParams = {
  wpagination?: boolean;
  limit?: number;
  page?: number;
  query?: string;
  categoryType?: number;
};
export const accessRoleApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getSubAdmin: builder.query<
      CommonResponseType & {
        data: {
          list: SubAdminResponse[];
          totalCount: number;
          totalPages: number;
        };
      },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.subadmin}/list?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),

    getAllRoles: builder.query<
      CommonResponseType & { data: GetAllRolesResponse },
      {
        page: number;
        limit: number;
        search: string;
      }
    >({
      query: ({ page, limit, search }) => ({
        url: `${END_POINTS.accessRole}/list?page=${page}&limit=${limit}${
          search?.length ? `&search=${search}` : ""
        }`,
        method: "GET",
      }),
    }),
    getRoleById: builder.query<
      CommonResponseType & { data: any },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.accessRole}/${id}`,
        method: "GET",
      }),
    }),
    addRole: builder.mutation<
      CommonResponseType & { data: any },
      { body: CommonBody }
    >({
      query: ({ body }) => ({
        url: END_POINTS.accessRole,
        method: "POST",
        body,
      }),
    }),
    updateRoleById: builder.mutation<
      CommonResponseType & { data: any },
      { id: string; body: CommonBody }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.accessRole}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteRoleById: builder.mutation<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.accessRole}/${id}`,
        method: "DELETE",
      }),
    }),

    updateStatusSubAdmin: builder.mutation<
      CommonResponseType & { data: SubAdmin },
      {
        id: string;
        body: {
          isBlocked: boolean;
        };
      }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "PUT",
        body,
      }),
    }),

    getSubAdminById: builder.query<
      CommonResponseType & { data: SubAdminResponse },
      { id: string }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "GET",
      }),
    }),

    deleteSubadmin: builder.query<CommonResponseType, { id: string }>({
      query: ({ id }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "DELETE",
      }),
    }),

    addSubadminReal: builder.mutation<
      CommonResponseType & { data: SubAdmin },
      any
    >({
      query: (body) => ({
        url: END_POINTS.subadmin,
        method: "POST",
        body,
      }),
    }),

    updateCustomerReal: builder.mutation<
      CommonResponseType & { data: SubAdmin },
      { id: string; body: any }
    >({
      query: ({ id, body }) => ({
        url: `${END_POINTS.subadmin}/${id}`,
        method: "PUT",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllRolesQuery,
  useLazyGetAllRolesQuery,
  useLazyGetRoleByIdQuery,
  useAddRoleMutation,
  useUpdateRoleByIdMutation,
  useDeleteRoleByIdMutation,
  useLazyGetSubAdminQuery,
  useUpdateStatusSubAdminMutation,
  useLazyGetSubAdminByIdQuery,
  useLazyDeleteSubadminQuery,
  useAddSubadminRealMutation,
  useUpdateCustomerRealMutation,
} = accessRoleApi;
